import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeadersInterceptor } from './headers.interceptor';
import { HomeComponent } from './Layout/home.component';
import { LoaderComponent } from './loader/loader.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { SignupComponent } from './login/signup/signup.component'; 
import { NoauthLayoutComponent } from './noauth-layout/noauth-layout.component';
import { SharedModule } from './Shared Utilities/shared.module';
import { WelcomePageComponent } from './Layout/welcome-page/welcome-page.component';
import { HospitalDocVerificationComponent } from './Document Verification/hospital-doc-verification/hospital-doc-verification.component';
import { SchoolDocVerificationComponent } from './Document Verification/school-doc-verification/school-doc-verification.component';
import { ERPComponent } from './erp/erp.component';
import { SocietyDocVerificationComponent } from './Document Verification/society-doc-verification/society-doc-verification.component';
import { PageNotFoundComponent } from './Layout/page-not-found/page-not-found.component';
import { EncryptionServiceService } from './Common/EncryptionService/encryption-service.service';
import { EncryptionInterceptorService } from './Common/EncryptionService/encryption-interceptor.service';
import { UrlBasedLoginPageComponent } from './url-based-login-page/url-based-login-page.component';
import { HospitalLoginComponent } from './login/hospital-login/hospital-login.component';
import { HospitalSignupComponent } from './login/hospital-signup/hospital-signup.component';
import { HospitalResetPasswordComponent } from './login/hospital-reset-password/hospital-reset-password.component';
import { UrlBasedSignupPageComponent } from './url-based-signup-page/url-based-signup-page.component';
import { UrlBasedResetPasswordPageComponent } from './url-based-reset-password-page/url-based-reset-password-page.component';
import { SchoolResetPasswordComponent } from './login/school-reset-password/school-reset-password/school-reset-password.component';
import { SchoolLoginComponent } from './login/school-login/school-login/school-login.component';
import { SchoolSignupComponent } from './login/school-signup/school-signup.component';
import { WalkthroughVideoComponent } from './Common/Need_Help_Videos/walkthrough-video/walkthrough-video.component';
import { SocietyLoginComponent } from './login/society-login/society-login.component';
import { SocietyResetPasswordComponent } from './login/society-reset-password/society-reset-password.component';
import { SocietySignupComponent } from './login/society-signup/society-signup.component';
import { RevenueReportModule } from './Common/Revenue_Report/revenue-report.module/revenue-report.module.module';
import { ServiceAvailabilityComponent } from './Common/Service_Availabilty/service-availabilty/service-availabilty.component';
import { ModuleConfigComponent } from './Common/module-config/module-config.component';
import { RolesModuleComponent } from './Common/roles-module/roles-module.component';
import { MenumasterModuleComponent } from './Common/menumaster-module/menumaster-module.component';
import { SubroleModuleComponent } from './Common/subrole-module/subrole-module.component';
import { UsermenuConfigComponent } from './Common/usermenu-config/usermenu-config.component';
import { CrmLoginComponent } from './login/CRM/crm-login/crm-login.component';
import { CrmResetPasswordComponent } from './login/CRM/crm-reset-password/crm-reset-password.component';
import { CrmSignUpComponent } from './login/CRM/crm-sign-up/crm-sign-up.component';
import { CrmErrorInterceptor } from './CRM/shared/crm-error.interceptor';
import { SelfOnboardingComponent } from './Common/self-onboarding/self-onboarding.component';@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    NoauthLayoutComponent,
    SignupComponent,
    ResetPasswordComponent,
    LoaderComponent,
    WelcomePageComponent,
    HospitalDocVerificationComponent,
    SchoolDocVerificationComponent,
    ERPComponent,
    SocietyDocVerificationComponent,
    PageNotFoundComponent,
    UrlBasedLoginPageComponent,
    HospitalLoginComponent,
    HospitalSignupComponent,
    HospitalResetPasswordComponent,
    UrlBasedSignupPageComponent,
    UrlBasedResetPasswordPageComponent,
    SchoolResetPasswordComponent,
    SchoolLoginComponent,
    SchoolSignupComponent,
    WalkthroughVideoComponent,
    SocietyLoginComponent,
    SocietyResetPasswordComponent,
    SocietySignupComponent,
    ServiceAvailabilityComponent,
    ModuleConfigComponent,
    RolesModuleComponent,
    MenumasterModuleComponent,
    SubroleModuleComponent,
    UsermenuConfigComponent,
    CrmLoginComponent,
    CrmResetPasswordComponent,
    CrmSignUpComponent,
    SelfOnboardingComponent,
   
    
    
  ],
imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbTooltipModule,
    SharedModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RevenueReportModule
],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    {
      provide:HTTP_INTERCEPTORS,
      useClass:EncryptionInterceptorService,
      multi:true
    },
      {
    provide: HTTP_INTERCEPTORS,
    useClass: CrmErrorInterceptor,
    multi: true
   }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }